module.exports = __webpack_public_path__ + "static/bg03-bc42b4207cd7f403891f36134ad2c6ec.jpg";